import { render, staticRenderFns } from "./ConfigurarAlertaModal.vue?vue&type=template&id=9a86187c&"
import script from "./ConfigurarAlertaModal.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarAlertaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports